import type { FaireProductEntity } from "../../entity_types/product";

export const p_qrxstx7fm8: FaireProductEntity = {
  token: "p_qrxstx7fm8",
  type: "product",
  name: "Put Me In Coach",
  brandToken: "b_stzes6vr2c",
  brandName: "Al + Gray Graphic Tees",
  imageUrl:
    "https://cdn.faire.com/fastly/f738cac9c4cebdfedf8982757266943c3accca299d78353d60c13953ab1d26db.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f3ec42ad4ffb0d06f474eeb2af4a76b374853459df0df47af149ec35b42e58d.png",
  ],
  priceDollars: 14,
  description:
    'Step up your game with the "Put Me In Coach" hat—perfect for any sport, any time. \n\n * Mid Profile Baseball Cap \n * OTTO brand • Cotton Blend Twill\n * Black Puff Ink ',
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:13.737Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
